import axios from 'axios'
import { AxiosHeaders } from 'axios'

import { API_BASE_URL } from '../constants/environment'

export const api = axios.create({
  baseURL: API_BASE_URL,
})

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')

  const isAuthRoute = ['/usuarios/login', '/usuarios/loginextranet'].some((url) =>
    config.url?.startsWith(url)
  )

  if (token && !isAuthRoute) {
    if (!config.headers) {
      config.headers = new AxiosHeaders()
    }
    config.headers.set?.('Authorization', `${token}`)
    config.headers.set?.('Content-Type', 'application/json')
  }

  return config
})

api.interceptors.response.use(
(response) => response,
(error) => {
  console.error('❌ API Error:', {
    status: error.response?.status,
    statusText: error.response?.statusText,
    data: error.response?.data,
    headers: error.response?.headers,
    config: error.config
  });
  
  return Promise.reject(error);
});
